// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1fJVQ","selected":"styles_selected__3q234"};